/* eslint-disable no-console */
import { store } from "store/store";

import { initializeApp } from "firebase/app";
import {
  getDatabase,
  ref,
  onValue,
  update,
  off,
  remove,
  // query,
  // orderByChild,
  get,
  // startAt,
  // endAt,
} from "firebase/database";

import { getAuth } from "firebase/auth";
import { v4 as uuidv4 } from "uuid";
import { updateMainUser, removeMainUser } from "store/actions/mainUserActions";
import { newAlertMessage } from "store/actions/globalAlertActions";
import {
  updateOnnaDevices,
  removeOnnaDevices,
  addOnnaDeviceToProject,
  removeOnnaDevicesFromProject,
} from "store/actions/onnaDevicesActions";
// import {
//     updateClientReservationsStore,
//   removeClientReservation,
// } from "store/actions/clientsActions";
import { updateApartments, removeApartments } from "store/actions/apartmentsActions";
import { updateProjects, removeProjects } from "store/actions/projectsActions";

// import { updateReservations,
// removeReservations,
// addReservationEventStore,
// removeReservationEventStore,
// updateReservationEventsStore }
// from "store/actions/reservationsActions";
import { updateNotifications, removeNotifications } from "store/actions/notificationsActions";
import { removeOccupancy, updateOccupancy } from "store/actions/occupancyActions";
// import { updateProjectManagersStore } from "store/actions/projectManagersActions";
// import { removeChat } from "store/actions/chatActions";
// import {
//   removeServiceEventStore,
//   updateServiceEvents,
//   addServiceEventStore,
// } from "store/actions/servicesActions";
// import {
//    updateSupportCases,
//   removeSupportCases,
// } from "store/actions/supportActions";

// Initialize Firebase
import appConfig from "./appConfig";

const firebaseApp = initializeApp(appConfig);
const auth = getAuth(firebaseApp);

class database {
  constructor() {
    this.uid = undefined;
    this.database = getDatabase(firebaseApp);
    this.firebaseApp = firebaseApp;
    this.ref = undefined;
    this.auth = auth;
  }

  checkUserValidation(uid) {
    return new Promise((resolve) => {
      try {
        const userValidated = ref(this.database, `/users/${uid}/validated`);
        onValue(userValidated, (snapshot) => {
          if (snapshot.exists()) {
            resolve({ validation: snapshot.val(), mainUser: true });
          } else {
            const projectManager = ref(this.database, `/projectManagersData/${uid}`);
            onValue(projectManager, (projectManagerSnapshot) => {
              if (projectManagerSnapshot.exists()) {
                const projectManagerData = projectManagerSnapshot.val();
                const mainUserUid = projectManagerData?.mainUserId;
                const projectsProjectManager = projectManagerData?.projects;
                const projectManagerDisplayName = projectManagerData?.displayName || "";
                const projectManagerFeatures = projectManagerData?.features || {};

                resolve({
                  validation: true,
                  mainUser: false,
                  isProjectManager: true,
                  mainUserUid,
                  projectsProjectManager,
                  projectManagerDisplayName,
                  projectManagerFeatures,
                });
              } else {
                resolve({ validation: false, mainUser: false, isAClient: true });
              }
            });
          }
        });
      } catch {
        resolve({ validation: false, mainUser: false, isAClient: true });
      }
    });
  }

  async start(
    uid,
    isProjectManager = false,
    projectsProjectManager = {},
    projectManagerFeatures = {}
  ) {
    this.uid = uid;
    try {
      onValue(ref(this.database, `/users/${this.uid}`), (snapshot) => {
        if (snapshot.exists()) {
          const {
            onnaDevices,
            // clients,
            projects,
            apartments,
            notifications,
            // reservations,
            // services,
            // servicesCategories,
            occupancy,
            // chat,
            // support,
          } = snapshot.val();
          if (!onnaDevices) store.dispatch(removeOnnaDevices());
          if (!projects) store.dispatch(removeProjects());
          // if (!clients) store.dispatch(removeClientReservation());
          if (!apartments) store.dispatch(removeApartments());
          if (!notifications) store.dispatch(removeNotifications());
          // if (!reservations) store.dispatch(removeReservations());
          // if (!services) store.dispatch(removeServices());
          // if (!servicesCategories) store.dispatch(removeServicesCategories());

          if (!occupancy) store.dispatch(removeOccupancy());
          // if (!chat) store.dispatch(removeChat());
          // if (!support) store.dispatch(removeSupportCases());
        }
      });
      onValue(ref(this.database, `/users/${this.uid}/mainUserData`), (snapshot) => {
        const data = snapshot.val() || {};
        if (Object.hasOwnProperty.call(data, "token")) {
          delete data.token;
        }
        // console.log("mainUserData snapshot", { data });
        const normalizedMainUserData = {
          ...data,
          imageUrl: Object.prototype.hasOwnProperty.call(data, "imageUrl") ? data.imageUrl : null,
        };

        store.dispatch(updateMainUser(normalizedMainUserData));
      });
      onValue(ref(this.database, `/users/${this.uid}/onnaDevices`), (snapshot) => {
        const data = snapshot.val();
        store.dispatch(updateOnnaDevices(data));
      });
      onValue(ref(this.database, `/users/${this.uid}/projects`), (snapshot) => {
        const data = snapshot.val();

        if (!isProjectManager) {
          store.dispatch(updateProjects(data));
        } else {
          const projectData = Object.values(data || {}).filter(
            (project) => projectsProjectManager?.[project.uid]
          );
          const projectDataObj = Object.fromEntries(
            projectData.map((project) => {
              const projectFeatures = project?.features || {};
              const features = Object.fromEntries(
                Object.entries(projectFeatures).map(([key, isEnabledInProject]) => [
                  key,
                  isEnabledInProject && projectManagerFeatures?.[key],
                ])
              );
              features.apartments = projectManagerFeatures?.apartments;
              features.notifications = projectManagerFeatures?.notifications;
              features.settings = projectManagerFeatures?.settings;
              features.email = projectManagerFeatures?.email;
              features.devices = projectManagerFeatures?.devices;
              features.occupancy = projectManagerFeatures?.occupancy;
              features.cloudApis = projectManagerFeatures?.cloudApis;
              features.customApp = projectManagerFeatures?.customApp;
              features.metricsConfig = projectManagerFeatures?.metricsConfig;
              return [
                project.uid,
                {
                  ...project,
                  features,
                },
              ];
            })
          );
          store.dispatch(updateProjects(projectDataObj));
        }
      });
      // onValue(ref(this.database, `/users/${this.uid}/clients`), (snapshot) => {
      //   const data = snapshot.val();
      //   store.dispatch(updateClientReservationsStore(data));
      // });
      onValue(ref(this.database, `/users/${this.uid}/apartments`), async (snapshot) => {
        const data = snapshot.val();

        if (!isProjectManager) {
          store.dispatch(updateApartments(data));
        } else {
          try {
            const projectIds = Object.keys(projectsProjectManager || {});

            const projectApartmentsSnapshots = await Promise.all(
              projectIds.map((projectId) =>
                get(ref(this.database, `/users/${this.uid}/projects/${projectId}/apartments`))
              )
            );

            const authorizedApartmentIds = new Set();

            projectApartmentsSnapshots.forEach((projectApartmentsSnapshot) => {
              const projectApartments = projectApartmentsSnapshot.val() || {};

              Object.entries(projectApartments).forEach(([apartmentId]) => {
                authorizedApartmentIds.add(apartmentId);
              });
            });

            const filteredApartments = Object.fromEntries(
              Object.entries(data).filter(([apartmentId]) =>
                authorizedApartmentIds.has(apartmentId)
              )
            );

            store.dispatch(updateApartments(filteredApartments));
          } catch (error) {
            console.error("Error loading project manager apartments", error);

            store.dispatch(updateApartments({}));
          }
        }
      });
      // onValue(ref(this.database, `/users/${this.uid}/reservations`), (snapshot) => {
      //   const data = snapshot.val();
      //   store.dispatch(updateReservations(data));
      // });
      // onValue(ref(this.database, `/users/${this.uid}/reservationEvents`), (snapshot) => {
      //   const data = snapshot.val();
      //   store.dispatch(updateReservationEventsStore(data));
      // });
      // onValue(ref(this.database, `/users/${this.uid}/services`), (snapshot) => {
      //   const data = snapshot.val();
      //   store.dispatch(updateServices(data));
      // });
      // onValue(ref(this.database, `/users/${this.uid}/servicesCategories`), (snapshot) => {
      //   const data = snapshot.val();
      //   store.dispatch(updateServicesCategories(data));
      // });
      // onValue(ref(this.database, `/users/${this.uid}/serviceEvents`), (snapshot) => {
      //   const data = snapshot.val();
      //   store.dispatch(updateServiceEvents(data));
      // });
      onValue(ref(this.database, `/users/${this.uid}/occupancy`), (snapshot) => {
        const data = snapshot.val();
        store.dispatch(updateOccupancy(data));
      });
      onValue(ref(this.database, `/users/${this.uid}/notifications`), (snapshot) => {
        const data = snapshot.val();

        if (!isProjectManager) {
          const { mainUserReducer } = store.getState();
          store.dispatch(updateNotifications(data, mainUserReducer?.isMainUser));
        } else {
          const { mainUserReducer } = store.getState();
          const notificationData = Object.values(data || {}).filter(
            (notification) => projectsProjectManager?.[notification.projectId]
          );

          store.dispatch(updateNotifications(notificationData, mainUserReducer?.isProjectManager));
        }
      });
      // onValue(ref(this.database, `/users/${this.uid}/chat`), (snapshot) => {
      //   const data = snapshot.val();
      //   store.dispatch(updateChat(data));
      // });
      // onValue(ref(this.database, `/users/${this.uid}/supportByApartment`), (snapshot) => {
      //   store.dispatch(updateSupportCases(snapshot.val()));
      // });
    } catch (error) {
      console.log(error);
    }
  }

  async editCustomMenuConfigInMainUser(dataToSend) {
    const { menuConfig } = dataToSend;
    try {
      await update(ref(this.database, `/users/${this.uid}/mainUserData/customApp`), {
        menuConfig,
      });
    } catch (e) {
      console.log(e);
    }
  }

  async editCustomLangInMainUser(dataToSend) {
    const { customLang, useCustomWelcomeBackgroundColor, customWelcomeBackgroundColor } =
      dataToSend;

    try {
      await update(ref(this.database, `/users/${this.uid}/mainUserData/customApp`), {
        customLang,
        useCustomWelcomeBackgroundColor,
        customWelcomeBackgroundColor,
      });
    } catch (e) {
      console.log(e);
    }
  }

  async editCustomLangInProject(dataToSend) {
    const {
      projectId,
      customLang,
      useCustomWelcomeBackgroundColor,
      customWelcomeBackgroundColor,
      useCustomIconColor,
      customIconColor,
      useCustomAppBackgroundColor,
      customAppBackgroundColor,
      useCustomCardColor,
      customCardColor,
      useCustomFont,
      customFont,
    } = dataToSend;

    try {
      await update(ref(this.database, `/users/${this.uid}/projects/${projectId}/customAppConfig`), {
        customLang,
        useCustomWelcomeBackgroundColor,
        customWelcomeBackgroundColor,
        useCustomIconColor,
        customIconColor,
        useCustomAppBackgroundColor,
        customAppBackgroundColor,
        useCustomCardColor,
        customCardColor,
        useCustomFont,
        customFont,
      });
    } catch (e) {
      console.log(e);
    }
  }

  async editImageMainUser(imageUrl) {
    try {
      await update(ref(this.database, `/users/${this.uid}/mainUserData`), {
        imageUrl,
      });
    } catch (e) {
      console.log(e);
    }
  }

  async deleteImageMainUser() {
    try {
      await update(ref(this.database, `/users/${this.uid}/mainUserData`), {
        imageUrl: null,
      });
    } catch (e) {
      console.log(e);
    }
  }

  async editMainUserNotifications(notifications) {
    try {
      const { alerts, communication } = notifications;
      await update(ref(this.database, `/users/${this.uid}/mainUserData`), {
        alerts,
        communication,
      });
    } catch (e) {
      console.log(e);
    }
  }

  async editBasicInfoMainUser(basicInfo) {
    const {
      firstName,
      lastName,
      address,
      city,
      postcode,
      language,
      phoneNumber,
      company,
      vatNumber,
    } = basicInfo;

    try {
      await update(ref(this.database, `/users/${this.uid}/mainUserData/`), {
        firstName,
        lastName,
        address,
        city,
        postcode,
        language,
        phoneNumber,
        company,
        vatNumber,
      });
    } catch (e) {
      console.log(e);
    }
  }

  // async removeClientReservation(clients) {
  //   try {
  //     const updates = {};
  //     const promisesUsers = clients.map(async ({ apartmentId, uid }) => {
  //       updates[uid] = null;
  //       return remove(
  //         ref(this.database, `/users/${this.uid}/apartments/${apartmentId}/clients/${uid}`)
  //       );
  //     });
  //     await update(ref(this.database, `/users/${this.uid}/clients/`), updates);
  //     await Promise.all(promisesUsers);
  //   } catch (e) {
  //     console.log(e);
  //   }
  // }

  // async addClient(clientData) {
  //   const { apartmentId, uid } = clientData;
  //   console.log("DATABASE addClient", { clientData });
  //   if (apartmentId) {
  //     try {
  //       await update(ref(this.database, `/users/${this.uid}/clients/${uid}`), {
  //         ...clientData,
  //         createdAt: Date.now(),
  //       });
  //       const child = {};
  //       child[uid] = true;
  //       await update(
  //         ref(this.database, `/users/${this.uid}/apartments/${apartmentId}/clients`),
  //         child
  //       );
  //     } catch (e) {
  //       console.log(e);
  //     }
  //   }
  // }

  // async editClient(clientData) {
  //   const { uid } = clientData;
  //   try {
  //     await update(ref(this.database, `/users/${this.uid}/clients/${uid}`), clientData);
  //   } catch (e) {
  //     console.log(e);
  //   }
  // }

  async removeProject(projectIdToRemove) {
    try {
      if (this.uid && projectIdToRemove) {
        await remove(ref(this.database, `/users/${this.uid}/projects/${projectIdToRemove}`));
      }
    } catch (e) {
      console.log(e);
    }
  }

  async addProject(projectData) {
    const newUid = uuidv4();
    try {
      await update(ref(this.database, `/users/${this.uid}/projects/${newUid}`), {
        ...projectData,
        uid: newUid,
        createdAt: Date.now(),
      });
    } catch (e) {
      console.log(e);
    }
  }

  async editProject(projectData) {
    const { uid } = projectData;
    try {
      await update(ref(this.database, `/users/${this.uid}/projects/${uid}`), projectData);
    } catch (e) {
      console.log(e);
    }
  }

  // async removeReservations(reservationsData, projectId) {
  //   try {
  //     const updates = {};
  //     const promises = reservationsData.map(async ({ uid }) => {
  //       updates[uid] = null;
  //       return remove(
  //         ref(this.database, `/users/${this.uid}/projects/${projectId}/reservations/${uid}`)
  //       );
  //     });
  //     await update(ref(this.database, `/users/${this.uid}/reservations/`), updates);
  //     await Promise.all(promises);
  //   } catch (e) {
  //     console.log(e);
  //   }
  // }

  // async addReservation(reservationData, projectId) {
  //   const newUid = uuidv4();
  //   try {
  //     await update(ref(this.database, `/users/${this.uid}/reservations/${newUid}`), {
  //       ...reservationData,
  //       uid: newUid,
  //       createdAt: Date.now(),
  //     });
  //     const child = {};
  //     child[newUid] = true;
  //     await update(
  //       ref(this.database, `/users/${this.uid}/projects/${projectId}/reservations/`),
  //       child
  //     );
  //   } catch (e) {
  //     console.log(e);
  //   }
  // }

  // async editReservation(reservationData) {
  //   const { uid } = reservationData;
  //   try {
  //     await update(ref(this.database, `/users/${this.uid}/reservations/${uid}`), reservationData);
  //   } catch (e) {
  //     console.log(e);
  //   }
  // }

  // addReservationEvent(reservationEventData) {
  //   const { reservationId, event } = reservationEventData;
  //   const { apartmentId, id } = event;
  //   const eventId = id;

  //   event.start = new Date(event.start).valueOf();
  //   event.end = new Date(event.end).valueOf();

  //   event.startDateVal = event.start;

  //   // console.log("database data en addReservationEvent", { reservationEventData });
  //   const updates = {};

  //   updates[`/users/${this.uid}/reservationEvents/${reservationId}/${eventId}`] = event;
  //   updates[`/users/${this.uid}/reservationEventsByApartment/${apartmentId}/${eventId}`] = event;

  //   update(ref(this.database), updates)
  //     .then(() => {
  //       store.dispatch(addReservationEventStore({ reservationId, eventId, event }));
  //     })
  //     .catch(console.error);
  // }

  // removeReservationEvent(data) {
  //   const { reservationId, eventId, apartmentId } = data;
  //   // console.log("database data en removeReservationEvent", { data });
  //   const updates = {};

  //   updates[`/users/${this.uid}/reservationEvents/${reservationId}/${eventId}`] = null;
  //   updates[`/users/${this.uid}/reservationEventsByApartment/${apartmentId}/${eventId}`] = null;

  //   update(ref(this.database), updates)
  //     .then(() => {
  //       store.dispatch(removeReservationEventStore(data));
  //     })
  //     .catch(console.error);
  // }

  // getReservationEventsByServiceId(data, cb) {
  //   const { reservationId, startDate, endDate } = data;
  //   const startDateVal = new Date(startDate).valueOf();
  //   const endDateVal = new Date(endDate).valueOf();

  //   const newRef = query(
  //     ref(this.database, `/users/${this.uid}/reservationEvents/${reservationId}/`),
  //     orderByChild("startDateVal"),
  //     startAt(startDateVal),
  //     endAt(endDateVal)
  //   );
  //   get(newRef)
  //     .then((snapshot) => {
  //       if (snapshot.exists) {
  //         cb(snapshot.val());
  //       }
  //     })
  //     .catch((e) => {
  //       console.log(e);
  //     });
  // }

  // async removeServices(servicesData, projectId) {
  //   try {
  //     const updates = {};
  //     const promises = servicesData.map(async ({ uid }) => {
  //       updates[uid] = null;
  //       return remove(
  //         ref(this.database, `/users/${this.uid}/projects/${projectId}/services/${uid}`)
  //       );
  //     });
  //     await update(ref(this.database, `/users/${this.uid}/services/`), updates);
  //     await Promise.all(promises);
  //   } catch (e) {
  //     console.log(e);
  //   }
  // }

  // async addService(serviceData, projectId) {
  //   const newUid = uuidv4();
  //   try {
  //     await update(ref(this.database, `/users/${this.uid}/services/${newUid}`), {
  //       ...serviceData,
  //       uid: newUid,
  //       createdAt: Date.now(),
  //     });
  //     const child = {};
  //     child[newUid] = true;
  //     await update(ref(this.database, `/users/${this.uid}/projects/${projectId}/services/`), child);
  //   } catch (e) {
  //     console.log(e);
  //   }
  // }

  // async editService(serviceData) {
  //   const { uid } = serviceData;
  //   try {
  //     await update(ref(this.database, `/users/${this.uid}/services/${uid}`), serviceData);
  //   } catch (e) {
  //     console.log(e);
  //   }
  // }

  // async removeCategory(servicesData, projectId) {
  //   try {
  //     const updates = {};
  //     const promises = servicesData.map(async ({ uid }) => {
  //       updates[uid] = null;
  //       return remove(
  //         ref(this.database, `/users/${this.uid}/projects/${projectId}/servicesCategories/${uid}`)
  //       );
  //     });
  //     await update(ref(this.database, `/users/${this.uid}/servicesCategories/`), updates);
  //     await Promise.all(promises);
  //   } catch (e) {
  //     console.log(e);
  //   }
  // }

  // async addCategory(serviceData, projectId) {
  //   const newUid = uuidv4();
  //   try {
  //     await update(ref(this.database, `/users/${this.uid}/servicesCategories/${newUid}`), {
  //       ...serviceData,
  //       uid: newUid,
  //       createdAt: Date.now(),
  //     });
  //     const child = {};
  //     child[newUid] = true;
  //     await update(
  //       ref(this.database, `/users/${this.uid}/projects/${projectId}/servicesCategories/`),
  //       child
  //     );
  //   } catch (e) {
  //     console.log(e);
  //   }
  // }

  // async editCategory(serviceData) {
  //   const { uid } = serviceData;
  //   try {
  //     await update(ref(this.database, `/users/${this.uid}/servicesCategories/${uid}`), serviceData);
  //   } catch (e) {
  //     console.log(e);
  //   }
  // }

  // addServiceEvent(serviceEventData) {
  //   const { serviceId, event, projectId } = serviceEventData;
  //   const { apartmentId, id } = event;
  //   const eventId = id;
  //   event.start = new Date(event.start).valueOf();
  //   event.end = new Date(event.end).valueOf();
  //   event.startDateVal = event.start;
  //   // console.log("database data en addServiceEvent", { serviceEventData });
  //   const updates = {};
  //   // console.log({ serviceId, event, apartmentId, eventId });
  //   // console.log("uid", this.uid);
  //   updates[`/users/${this.uid}/serviceEvents/${serviceId}/${eventId}`] = event;
  //   updates[`/users/${this.uid}/serviceEventsByApartment/${apartmentId}/${eventId}`] = event;

  //   update(ref(this.database), updates)
  //     .then(() => {
  //       store.dispatch(addServiceEventStore({ ...event, projectId }));
  //     })
  //     .catch(console.error);
  // }

  // removeServiceEvent(data) {
  //   const { serviceId, eventId, apartmentId } = data;
  //   // console.log("database data en removeServiceEvent", { data });
  //   const updates = {};

  //   updates[`/users/${this.uid}/serviceEvents/${serviceId}/${eventId}`] = null;
  //   updates[`/users/${this.uid}/serviceEventsByApartment/${apartmentId}/${eventId}`] = null;

  //   update(ref(this.database), updates)
  //     .then(() => {
  //       store.dispatch(removeServiceEventStore(data));
  //     })
  //     .catch(console.error);
  // }

  // getServiceEvents(data, cb) {
  //   const { serviceId, startDate, endDate } = data;
  //   const startDateVal = new Date(startDate).valueOf();
  //   const endDateVal = new Date(endDate).valueOf();

  //   const newRef = query(
  //     ref(this.database, `/users/${this.uid}/serviceEvents/${serviceId}/`),
  //     orderByChild("startDateVal"),
  //     startAt(startDateVal),
  //     endAt(endDateVal)
  //   );
  //   get(newRef)
  //     .then((snapshot) => {
  //       if (snapshot.exists) {
  //         cb(snapshot.val());
  //       }
  //     })
  //     .catch((e) => {
  //       console.log(e);
  //     });
  // }

  // async addSupportCase(data) {
  //   const newUid = uuidv4();
  //   const { apartmentId } = data;

  //   const newData = {
  //     ...data,
  //     supportCaseId: newUid,
  //     createdAt: Date.now(),
  //   };

  //   const updates = {};
  //   updates[`/users/${this.uid}/support/${newUid}`] = newData;
  //   updates[`/users/${this.uid}/supportByApartment/${apartmentId}/${newUid}`] = newData;

  //   try {
  //     await update(ref(this.database), updates);
  //   } catch (e) {
  //     console.log(e);
  //   }
  // }

  // async editSupportCase(data) {
  //   const { supportCaseId, apartmentId } = data;

  //   const updates = {};
  //   updates[`/users/${this.uid}/support/${supportCaseId}`] = data;
  //   updates[`/users/${this.uid}/supportByApartment/${apartmentId}/${supportCaseId}`] = data;

  //   try {
  //     await update(ref(this.database), updates);
  //   } catch (e) {
  //     console.log(e);
  //   }
  // }

  // async removeSupportCase({ supportCaseId, apartmentId }) {
  //   const updates = {};
  //   updates[`/users/${this.uid}/support/${supportCaseId}`] = null;
  //   updates[`/users/${this.uid}/supportByApartment/${apartmentId}/${supportCaseId}`] = null;

  //   try {
  //     await update(ref(this.database), updates);
  //   } catch (e) {
  //     console.log(e);
  //   }
  // }

  async removeOnnaDevices(onnaDevicesData, projectId) {
    try {
      new Promise((resolve, reject) => {
        store.dispatch(
          removeOnnaDevicesFromProject({
            userId: this.uid,
            onnaIds: onnaDevicesData.map(({ onnaId }) => onnaId),
            resolve,
            reject,
          })
        );
      }).then(async () => {
        const updates = {};
        const promisesProject = onnaDevicesData.map(async ({ onnaId }) => {
          updates[onnaId] = null;
          return remove(
            ref(this.database, `/users/${this.uid}/projects/${projectId}/onnaDevices/${onnaId}`)
          );
        });
        await update(ref(this.database, `/users/${this.uid}/onnaDevices/`), updates);
        await Promise.all(promisesProject);
      });
    } catch (e) {
      console.log(e);
    }
  }

  async addOnnaDevice(onnaDeviceData, projectId) {
    const { onnaId } = onnaDeviceData;
    try {
      new Promise((resolve, reject) => {
        store.dispatch(
          addOnnaDeviceToProject({
            userId: this.uid,
            projectId,
            onnaId,
            resolve,
            reject,
          })
        );
      })
        .then(async () => {
          await update(ref(this.database, `/users/${this.uid}/onnaDevices/${onnaId}`), {
            ...onnaDeviceData,
            createdAt: Date.now(),
          });
          const child = {};
          child[onnaId] = true;
          await update(
            ref(this.database, `/users/${this.uid}/projects/${projectId}/onnaDevices/`),
            child
          );
        })
        .catch((error) => {
          switch (error) {
            case "alreadyAssigned":
              store.dispatch(
                newAlertMessage({
                  type: "warning",
                  title: "addOnnaDevice",
                  content: "alreadyAssigned",
                })
              );
              break;
            case "notOpen":
              store.dispatch(
                newAlertMessage({ type: "warning", title: "addOnnaDevice", content: "notOpen" })
              );
              break;
            case "uknownDevice":
              store.dispatch(
                newAlertMessage({
                  type: "error",
                  title: "addOnnaDevice",
                  content: "uknownDevice",
                })
              );
              break;
            default:
              store.dispatch(
                newAlertMessage({ type: "error", title: "addOnnaDevice", content: "uknownError" })
              );
              break;
          }
        });
    } catch (e) {
      console.log(e);
    }
  }

  async editOnnaDevice(onnaDeviceData) {
    const { onnaId } = onnaDeviceData;
    try {
      await update(ref(this.database, `/users/${this.uid}/onnaDevices/${onnaId}`), onnaDeviceData);
    } catch (e) {
      console.log(e);
    }
  }

  async importApartments(apartments, projectId) {
    try {
      const imports = {};
      const apartmentIds = {};
      apartments.forEach((apartment) => {
        const { apartmentId } = apartment;
        if (apartmentId) {
          imports[apartmentId] = { ...apartment, createdAt: Date.now() };
          apartmentIds[apartmentId] = true;
        }
      });
      await update(
        ref(this.database, `/users/${this.uid}/projects/${projectId}/apartments/`),
        apartmentIds
      );
      await update(ref(this.database, `/users/${this.uid}/apartments/`), imports);
    } catch (e) {
      console.log(e);
    }
  }

  async addApartment(apartmentData, projectId) {
    const { apartmentId } = apartmentData;
    try {
      await update(ref(this.database, `/users/${this.uid}/apartments/${apartmentId}`), {
        ...apartmentData,
        createdAt: Date.now(),
      });
      const child = {};
      child[apartmentId] = true;
      await update(
        ref(this.database, `/users/${this.uid}/projects/${projectId}/apartments/`),
        child
      );
    } catch (e) {
      console.log(e);
    }
  }

  async editApartment(apartmentData) {
    const { apartmentId } = apartmentData;
    try {
      await update(
        ref(this.database, `/users/${this.uid}/apartments/${apartmentId}`),
        apartmentData
      );
    } catch (e) {
      console.log(e);
    }
  }

  async removeApartments(apartmentsData, projectId) {
    try {
      const updates = {};
      const promises = apartmentsData.map(async ({ apartmentId }) => {
        updates[apartmentId] = null;
        return remove(
          ref(this.database, `/users/${this.uid}/projects/${projectId}/apartments/${apartmentId}`)
        );
      });
      await update(ref(this.database, `/users/${this.uid}/apartments/`), updates);
      await Promise.all(promises);
    } catch (e) {
      console.log(e);
    }
  }

  // async removeNotifications(uids) {
  //   try {
  //     const updates = {};
  //     uids.forEach((index) => {
  //       updates[index] = null;
  //     });
  //     await update(ref(this.database, `/users/${this.uid}/notifications/`), updates);
  //   } catch (e) {
  //     console.log(e);
  //   }
  // }

  // async editNotifications(notificationsData) {
  //   try {
  //     await update(ref(this.database, `/users/${this.uid}/notifications/`), notificationsData);
  //   } catch (e) {
  //     console.log(e);
  //   }
  // }

  async stop() {
    try {
      off(ref(this.database, `/users/${this.uid}/mainUserData/`));
      off(ref(this.database, `/users/${this.uid}/onnaDevices/`));
      off(ref(this.database, `/users/${this.uid}/projects/`));
      // off(ref(this.database, `/users/${this.uid}/clients/`));
      off(ref(this.database, `/users/${this.uid}/apartments/`));
      off(ref(this.database, `/users/${this.uid}/notifications/`));
      // off(ref(this.database, `/users/${this.uid}/reservations/`));
      // off(ref(this.database, `/users/${this.uid}/services/`));
      // off(ref(this.database, `/users/${this.uid}/servicesCategories/`));
      // off(ref(this.database, `/users/${this.uid}/support/`));
      store.dispatch(removeMainUser());
      store.dispatch(removeOnnaDevices());
      store.dispatch(removeProjects());
      // store.dispatch(removeClientReservation());
      store.dispatch(removeApartments());
      store.dispatch(removeNotifications());
      // store.dispatch(removeReservations());
      // store.dispatch(removeServices());
      // store.dispatch(removeSupportCases());
      // store.dispatch(removeServicesCategories());
    } catch (error) {
      console.log(error);
    }
  }
}

export default database;
